import jwt from '@/auth/jwt/useJwt'
import ability from '@/libs/acl/ability'
import JwtService from '@/auth/jwt/jwtService'

export default {
  namespaced: true,

  state: {
    user: null,
    loaded: false,
  },

  mutations: {
    SET_USER(state, user) {
      state.user = user
    },
    SET_LOADED(state, value) {
      state.loaded = value
    },
  },

  actions: {
    async fetchUser({ commit }) {
      try {
        const { data } = await jwt.axiosIns.get(jwt.jwtConfig.userDataEndpoint)
        if (!JwtService.verifyMeResponse(data)) {
          data.payload.ability = []
        }
        ability.update(data.payload.ability)
        commit('SET_USER', data.payload)
      } catch (e) {
        commit('SET_USER', null)
      } finally {
        commit('SET_LOADED', true)
      }
    },

    clear({ commit }) {
      commit('SET_USER', null)
      commit('SET_LOADED', false)
    },
  },

  getters: {
    isAuthenticated: state => !!state.user,
    user: state => state.user,
    isLoaded: state => state.loaded,
  },
}
